// src/universal/hooks/useFeatureFlagSubscription/helpers.ts
var checkFeatureFlag = (flag, userId) => {
  if (!flag) {
    return false;
  }
  const { isGlobal, allowedUserIds } = flag;
  if (isGlobal) {
    return true;
  }
  if (!allowedUserIds) {
    return false;
  }
  if (!(userId == null ? void 0 : userId.trim())) {
    return false;
  }
  return allowedUserIds.includes(userId);
};

export { checkFeatureFlag };
//# sourceMappingURL=chunk-FKQPHPFM.mjs.map
//# sourceMappingURL=chunk-FKQPHPFM.mjs.map